// extracted by mini-css-extract-plugin
module.exports = {"star":"stars_star__4EXOY","star0":"stars_star0___KMS_","star--left":"stars_star--left__gj7a8"};